import { Link } from 'react-router-dom'
import { translations } from '../translations'
import { app, translate } from '../app'
import { languages } from '../locale'
import { NoFound } from './notfound'
import { Button } from './button'

interface NotFoundPageProps { title: string, subTitle: string }

export default function NotFoundPage({ title, subTitle }: NotFoundPageProps) {
  const locale = languages[app.locale]?.zendesk as string ?? app.locale

  return <div className='w-full  flex flex-col justify-center items-center h-full'>
    <NoFound />
    <h3>
      {title}
    </h3>
    <div className='text-sm text-gray-500'>
      {subTitle}
    </div>
    <Button className='mt-4'>
      <Link className='text-white' to={`/${locale.toLowerCase()}`}>{translate(translations.navigateHome)}</Link>
    </Button>
  </div>

}
